<template>
  <div class="newmenu_ly newmenu-layer">
    <div class="newmenu-head">
      <button type="button" class="show-totalmenu officehome-menu" @click="setMenuDetailVisible(true)">
        {{ $t('show-all-menu') }} <i class="gi gi-short-arrow-right-alt gt-ml-5"></i>
      </button>
    </div>
    <div class="newmenu-body gt-clearfix">
      <div class="service-menu gt-clearfix">
        <ul class="service-menu-list">
          <li class="service-menu-link-wrap" v-for="menuInfo in isVisibleMenuInfoList" v-bind:key="menuInfo.menu_type">
            <PayzonMenuItem v-if="menuInfo.menu_type === 'PAYZON_LINK'" :menu-info="menuInfo" />
            <a
              v-else
              :href="getUrlByMenuInfo(menuInfo)"
              :target="menuInfo.target"
              class="service-menu-link officehome-menu"
            >
              <span class="svg-span" v-html="menuInfo.icon"></span>
              <span class="link-name">{{ menuInfo.name }}</span>
              <span class="gt-badge" v-show="getMenuRecentCount(menuInfo.menu_type)">
                {{ getBadgeString(menuInfo.menu_type) }}
              </span>
            </a>
          </li>
        </ul>
      </div>

      <MenuBasicRight
        :intranet-list="intranetList"
        :bookmark-list="bookmarkList"
        :group-list="groupList"
        :my-plus-app-list="myPlusAppList"
        @click-plus-app="clickPlusApp"
        @show-bookmark-order-setting="showBookmarkOrderSetting"
        @click-intranet="clickIntranet"
      />
    </div>
    <MenuBanner v-if="isMenuBannerValid" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MenuBasicRight from './MenuBasicRight';
import PayzonMenuItem from './Payzon/PayzonMenuItem.vue';
import MenuBanner from '@/components/Menu/MenuBanner.vue';

export default {
  name: 'MenuBasic.vue',
  components: {
    MenuBanner,
    PayzonMenuItem,
    MenuBasicRight,
  },
  props: {
    isMenuDetailVisible: {
      type: Boolean,
      required: true,
    },
    domain: {
      type: String,
      required: true,
    },
    menuInfoList: {
      type: Array,
      required: true,
    },
    intranetList: {
      type: Array,
      required: true,
    },
    bookmarkList: {
      type: Array,
      required: true,
    },
    groupList: {
      type: Array,
      required: true,
    },
    myPlusAppList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getMenuRecentCount: 'menu/getMenuRecentCount',
      isMenuBannerValid: 'banner/isMenuBannerValid',
    }),
    isVisibleMenuInfoList() {
      return this.menuInfoList.filter((menuInfo) => {
        return menuInfo.is_favorite && menuInfo.is_use;
      });
    },
  },
  methods: {
    showBookmarkOrderSetting() {
      this.$emit('set-bookmark-order-setting-visible', true);
    },
    getBadgeString(menuType) {
      let menuRecentCount = this.getMenuRecentCount(menuType);
      if (!menuRecentCount) {
        return null;
      }

      if (menuType === 'NOTES_LINK') {
        if (!menuRecentCount) {
          return '';
        }
        if (menuRecentCount > 999) {
          return '999+';
        }

        return menuRecentCount;
      }

      if (menuType === 'SHARED_LINK') {
        if (menuRecentCount) {
          return 'N';
        }
      } else {
        if (menuRecentCount > 999) {
          return '999+';
        }

        return menuRecentCount;
      }
    },
    setMenuDetailVisible(isVisible) {
      this.$emit('set-menu-detail-visible', isVisible);
    },
    getUrlByMenuInfo(menuInfo) {
      if (menuInfo.is_include_domain) {
        return menuInfo.sub_domain + '/' + menuInfo.domain + menuInfo.url;
      }
      return menuInfo.sub_domain + menuInfo.url;
    },
    clickPlusApp(myPlusApp) {
      this.$emit('click-plus-app', myPlusApp);
    },
    clickIntranet(bookmark) {
      this.$emit('click-intranet', bookmark);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins/icon';
.newmenu-layer {
  //position: fixed;
  position: absolute;
  top: 60px;
  left: 10px;
  z-index: 5;

  @media (min-width: 900px) {
    left: 100px;
  }
}

.newmenu_ly {
  box-sizing: border-box;
  width: 355px;
  background: #fff;
  border-radius: 4px;
  border: solid 1px #aeaeae;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  overflow-y: scroll;
  max-height: calc(100vh - 70px);

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 900px) {
    width: 620px;
  }

  .newmenu-head {
    position: relative;
    box-sizing: border-box;
    padding: 24px 0 15px 30px;

    .show-totalmenu {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #2985db;
    }
  }

  .newmenu-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    @media (min-width: 900px) {
      flex-direction: row;
    }
    .favorite-star {
      color: #fdc036;
      width: 28px;
      height: 28px;
      flex-shrink: 0;
      outline: 0;
      i {
        font-size: 14px;
      }
      .gi {
        color: #aeaeae;
      }
      &:hover {
        .gi {
          color: #fdc036;
        }
        .gis {
          color: #fdc036;
        }
      }
    }
    .service-menu {
      margin: 0 20px;
      padding: 0 0 20px;
      border-bottom: 1px solid #cbcbcb;
      @media (min-width: 900px) {
        width: 405px;
        padding: 0 30px;
        margin: 0 0 23px;
        border-bottom: none;
        border-right: 1px solid #cbcbcb;
        overflow-y: scroll;
        // -ms-overflow-style: none;
        // &::-webkit-scrollbar {
        //   display: none;
        // }
      }
      &.gt-clearfix {
        &::after {
          display: block;
          content: '';
          clear: both;
        }
      }
      .service-menu-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        row-gap: 4px;
        @media (min-width: 900px) {
          max-height: 301.5px;
        }
        .service-menu-link-wrap {
          box-sizing: border-box;
          display: flex;
          align-items: center;
          flex-basis: 50%;
          max-width: 50%;
          // min-width: 156px;
          // max-width: 156px;
          height: 40px;
          padding-left: 8px;
          flex-grow: 1;
          .service-menu-link {
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 1.79;
            color: #333;
            overflow: hidden;
            flex-grow: 1;
            height: 100%;
            .svg-span {
              display: flex;
              align-items: center;
              box-sizing: content-box;
            }
            .link-name {
              margin-left: 8px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .gt-badge {
              display: inline-block;
              height: 16px;
              padding: 0 5px;
              line-height: 1.45;
              border-radius: 500px;
              background: #2985db;
              color: #fff;
              font-size: 11px;
              margin-left: 5px;
              user-select: none;
            }
          }

          &:hover {
            background: #eff4fc;
            ::v-deep .svg-hover-color {
              fill: #4e9bd4;
            }
            .service-menu-link {
              color: #2985db;
            }
          }
        }
      }
    }
  }
  & .gt-clearfix {
    &::after {
      display: block;
      content: '';
      clear: both;
    }
  }
}
</style>
